<script>
	let step, amount, account, orderid;
	const searchParams = new URLSearchParams(window.location.search);

	if (searchParams.has('p')) {
		let payment_data = searchParams.get('p');
		try {
			payment_data = atob(payment_data);
			payment_data = JSON.parse(payment_data);
			if ('orderid' in payment_data && 'amount' in payment_data && 'account' in payment_data) {
				step = "pay";
				amount = payment_data.amount;
				account = payment_data.account;
				if (payment_data.orderid) {
					orderid = `#${payment_data.orderid}FRSH`;
				} else {
					orderid = "";
				}
			}
		} catch {
			step = "home";
		}
	} else {
		step = "home";
	}
</script>

<svelte:head>
	<script src="https://cdn.tailwindcss.com"></script>
</svelte:head>

<main>
	<div class="flex flex-col justify-center items-center w-screen h-screen bg-[url('/assets/img/bg.webp')] bg-cover bg-no-repeat select-none">

		<!-- Pay -->
		{#if step == "pay"}
			<div class="shadow-xl py-5 px-5 rounded mx-6 bg-white">
				<div class="flex">
					<div class="block mr-auto">
						<img src="/assets/img/d17.jpg" class="w-32 mt-2" alt="D17 Logo">
					</div>
					<div class="block">
						<img src="/assets/img/freshboublech.png" class="w-24 mt-0" alt="Fresh Boublech Logo">
					</div>
				</div>
				<h1 class="font-bold text-2xl mt-6">Payer avec D-17</h1>
				<p class="text-gray-600">Montant: {amount}</p>
				<br>
					<p class="font-bold text-4xl">{account}</p>   
					<p class="text-gray-600">Compte E-Dinar</p>
				<br>
				<ol>
					<li class="my-2">1. Ouvrez l'application D-17 sur votre téléphone.</li>
					<li class="my-2">2. Envoyez le montant de la commande {amount} au le <br><div class="mr-2"></div>compte E-Dinar <span class="underline">{account}</span>.</li>
					<li class="my-2">3. Cliquez sur Paiement Effectué.</li>
				</ol>
				<button class="w-full bg-blue-800 hover:bg-gray-600 rounded drop-shadow py-3 mt-5 duration-300" on:click={() => {step = "confirm"}}>
					<p class="text-center text-white font-medium">Paiement Effectué</p>
				</button>
				<p class="text-sm mt-5">Revenir à <a href="https://freshboublech.store" class="text-blue-600 underline">Fresh Boublech</a>.</p>
			</div>
		{/if}

		<!-- Confirm -->
		{#if step == "confirm"}
			<div class="shadow-xl py-5 px-5 rounded mx-6 bg-white">
				<div class="flex">
					<div class="block mr-auto">
						<img src="/assets/img/d17.jpg" class="w-32 mt-2" alt="D17 Logo">
					</div>
					<div class="block">
						<img src="/assets/img/freshboublech.png" class="w-24 mt-0" alt="Fresh Boublech Logo">
					</div>
				</div>
				<h1 class="font-bold text-2xl mt-6">Confirmer Le Paiement D-17</h1>
				<p class="text-gray-600">Montant: {amount}</p>
				<form class="mt-4 min-w-72" action="https://formsubmit.co/contact@freshboublech.store" method="POST">
					<p class="text-lg">Numéro de commande:</p>
					<div class="flex justify-center items-center relative">
						<div class="bg-gray-400 absolute left-0 pt-2.5 pb-2.5 top-2 rounded-tl rounded-bl px-2 text-white">
							<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-hash" viewBox="0 0 16 16">
								<path d="M8.39 12.648a1.32 1.32 0 0 0-.015.18c0 .305.21.508.5.508.266 0 .492-.172.555-.477l.554-2.703h1.204c.421 0 .617-.234.617-.547 0-.312-.188-.53-.617-.53h-.985l.516-2.524h1.265c.43 0 .618-.227.618-.547 0-.313-.188-.524-.618-.524h-1.046l.476-2.304a1.06 1.06 0 0 0 .016-.164.51.51 0 0 0-.516-.516.54.54 0 0 0-.539.43l-.523 2.554H7.617l.477-2.304c.008-.04.015-.118.015-.164a.512.512 0 0 0-.523-.516.539.539 0 0 0-.531.43L6.53 5.484H5.414c-.43 0-.617.22-.617.532 0 .312.187.539.617.539h.906l-.515 2.523H4.609c-.421 0-.609.219-.609.531 0 .313.188.547.61.547h.976l-.516 2.492c-.008.04-.015.125-.015.18 0 .305.21.508.5.508.265 0 .492-.172.554-.477l.555-2.703h2.242l-.515 2.492zm-1-6.109h2.266l-.515 2.563H6.859l.532-2.563z"/>
							</svg>
						</div>
						<input class="border rounded w-full pl-12 py-2 border focus:outline-none mt-2" type="text" name="Order ID/Number" placeholder="Exemple: #1000FRSH" minlength="5" maxlength="100" bind:value={orderid} required>
					</div>
					<p class="text-lg mt-4">Numéro de téléphone utilisé pour envoyer le paiement:</p>
					<div class="flex justify-center items-center relative">
						<div class="bg-gray-400 absolute left-0 pt-3 pb-3 top-2 rounded-tl rounded-bl px-2.5 text-white">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
								<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
							</svg>
						</div>
						<input class="border rounded w-full pl-12 py-2 border focus:outline-none mt-2" type="text" name="D-17 Phone Number" minlength="8" maxlength="100" placeholder="Exemple: 22 222 222" required>
					</div>
					<input type="hidden" name="_subject" value="New D-17 Payment - Fresh Pay" hidden>
					<input type="hidden" name="_template" value="table" hidden>
					<input type="hidden" name="_next" value="https://pay.freshboublech.store/done" hidden>
					<input type="hidden" name="_captcha" value="false" hidden>
					<button type="submit" class="bg-blue-800 hover:bg-gray-600 text-white w-full rounded shadow py-3 mt-6 duration-300">Confirmer Le Paiement</button>
				</form>
				<p class="text-sm mt-5">Revenir à <a href="https://freshboublech.store" class="text-blue-600 underline">Fresh Boublech</a>.</p>
			</div>
		{/if}

		{#if step == "home"}
			<div class="shadow-xl py-5 px-5 rounded mx-6 bg-white">
				<div class="flex">
					<div class="block">
						<img src="/assets/img/freshboublech.png" class="w-24 mt-0" alt="Fresh Boublech Logo">
					</div>
				</div>
				<h1 class="font-bold text-2xl mt-6">Fresh Pay</h1>
				<p class="text-gray-600">A Payment Gateway For Fresh Boublech.</p>
				<div class="px-48"></div>
				<p class="my-12">You currently don't have any active payments yet.</p>
				<p class="text-sm mt-5">Return to <a href="https://freshboublech.store" class="text-blue-600 underline">Fresh Boublech</a>.</p>
			</div>
		{/if}
    </div>
</main>
